window.addEventListener('load', function () {
  if (window.innerWidth > 768) return;

  document.querySelectorAll('.read-more-block').forEach(function (block) {
    const lineHeight = parseFloat(getComputedStyle(block).lineHeight) || 24;
    const maxHeight = lineHeight * 3;

    if (block.scrollHeight <= maxHeight + 5) return;

    block.style.maxHeight = maxHeight + 'px';
    block.style.overflow = 'hidden';
    block.style.transition = 'max-height 0.3s ease';

    const btn = block.nextElementSibling;
    btn.style.cssText = 'display:block;background:none;border:none;color:inherit;cursor:pointer;font-size:0.9em;padding:4px 0;text-decoration:underline;margin-top:6px;';

    let expanded = false;
    btn.addEventListener('click', function () {
      expanded = !expanded;
      block.style.maxHeight = expanded ? block.scrollHeight + 'px' : maxHeight + 'px';
      btn.textContent = expanded ? 'Réduire ▴' : 'Lire la suite ▾';
    });
  });
});
